import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/starter-kits/g2-starter-kit.png";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import { touchPassSupport } from "../properties";
import { includedAccessories } from "../properties/includedAccessories";
import { includedHub } from "../properties/includedHub";
import { includedReaders } from "../properties/includedReaders";

export const g2StarterKit: Product = {
  id: "g2StarterKit",
  productTitle: "G2 Starter Kit",
  description: "g2StarterKit.description",
  productListGroup: starterKits,
  descriptionMaxWidth: 200,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-g2-sk"],
  storePathParts: { category: "all-door-access", productSlug: "ua-g2-sk" },
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "g2StarterKit.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "g2StarterKit.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "g2StarterKit.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
  ],
};
